/** @format */
import {YalperAnalyticAttributionModelEnum} from 'graphql/generated/types';

import {ColumnType} from 'components/Table/core/types';

export const MIN_CALENDAR_RANGE_DAYS = 30;
export const MAX_CALENDAR_RANGE_DAYS = 180;
export const MAX_GOAL_SELECTIONS = 10;
export const MENU_PROPS = {
  PaperProps: {
    style: {
      width: 250,
      backgroundColor: '#3C3C3C',
      borderRadius: '8px',
      border: '1px solid #4A4A4A',
      marginTop: '4px',
    },
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
};

export const KPI_OPTIONS = [
  {value: 'DRR', text: 'ДРР (Доля рекламных расходов)'},
  {value: 'CPL', text: 'CPL (Cost per lead)'},
];

type AttributionOption = {value: YalperAnalyticAttributionModelEnum; text: string};

export const ATTRIBUTION_OPTIONS: AttributionOption[] = [
  {value: 'AUTOMATIC', text: 'Автоматическая'},
  {value: 'FIRST', text: 'Первый переход'},
  {value: 'LAST', text: 'Последний переход'},
  {value: 'LASTSIGN', text: 'Последний значимый переход'},
  {value: 'LAST_YANDEX_DIRECT_CLICK', text: 'Последний клик из Яндекс.Директа'},
  {
    value: 'CROSS_DEVICE_FIRST',
    text: 'Первое взаимодействие на всех устройствах',
  },
  {
    value: 'CROSS_DEVICE_LAST',
    text: 'Последнее взаимодействие на всех устройствах',
  },
  {
    value: 'CROSS_DEVICE_LAST_SIGNIFICANT',
    text: 'Последнее значимое взаимодействие на всех устройствах',
  },
  {
    value: 'CROSS_DEVICE_LAST_YANDEX_DIRECT_CLICK',
    text: 'Последний клик из Яндекс.Директа на всех устройствах',
  },
];

export const TOOLTIP_TEXTS = {
  CAMPAIGNS:
    'Выберите кампании, которые нужно проанализировать. Если у вас разные KPI для разных типов кампаний (брендовые, поиск/сети и т.д.), выбирайте кампании с одинаковой целью и запускайте анализ по отдельным сегментам с подходящим KPI.',
  PERIOD:
    'Интервал сбора статистики для анализа (дата начала — дата конца). Минимальный период - 1 месяц. Максимальный - 6 месяцев.',
  GOALS:
    'Выберите цели из Яндекс.Метрики, которые необходимо использовать для анализа. Если выбрать несколько целей, их конверсии суммируются и будут учитываться в KPI.',
  KPI: 'Ключевая метрика, по которой оцениваете эффективность кампаний. Выберите метрику и укажите целевое значение - система подберёт гипотезы, которые помогут её достичь.',
  ATTRIBUTION:
    'Правило распределения конверсий между каналами. Рекомендуем выбирать ту же модель, что в вашей системе аналитики, чтобы оценки отчёта были сопоставимы с текущими данными.',
  BUDGET: 'Укажите общий бюджет на период (включая НДС)',
};

export const campaignColumns: ColumnType[] = [
  {
    id: 'campaignId',
    title: 'ID',
    size: 100,
  },
  {
    id: 'campaignName',
    title: 'Название',
    size: 300,
  },
  {
    id: 'accountName',
    title: 'Субаккаунт',
    size: 100,
  },
];

export const goalColumns: ColumnType[] = [
  {id: 'counterId', title: 'ID Метрики'},
  {id: 'counterName', title: 'Название Метрики'},
  {id: 'id', title: 'ID цели'},
  {id: 'name', title: 'Название Цели'},
];
